import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalService, TriggeredEvent } from '../../../service/local.service';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})
export class MessageComponent implements OnInit {
  @Input() message: string; maxBodyHeight = 0; @Input() IsHtmlMessage = false;
  @Input() IsConfirmationType = false; @Input() header = ''; @Input() customButtonText = '';
  interval; @Input() timerValue: number | undefined = undefined;//In seconds
  timerCount = 0; @Input() IsYesPrimaryOnConfirmationType = false;
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private activeModal: NgbActiveModal, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    if (this.timerValue) {
      this.startTimer();
    }
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onPopupClose() {
    this.activeModal.close({ event: TriggeredEvent.Close });
  }

  onConfirmed(isConfirmed) {
    this.activeModal.close({ event: isConfirmed ? TriggeredEvent.Ok : TriggeredEvent.Close });
  }

  onCloseMessageBox(e) {
    this.activeModal.close(e);
  }

  startTimer() {
    this.timerCount = this.timerValue;
    this.interval = setInterval(() => {
      this.timerCount--;
      if (this.timerCount == 0) {
        this.onConfirmed(true);
      }
    }, 1000); //1 sec
  }

  ngOnDestroy(): void {
    clearInterval(this.interval);
  }
}
